<template>
  <v-card class="page-root pa-0 ma-0 d-flex flex-column">
    <!--tabs menu setting -->
    <v-tabs v-model="tab" class="custom-tabs">
      <!--titles tabs menu setting -->
      <v-tab class="custom-tab text-body-2">{{ $t("insurance_disc") }}</v-tab>
      <v-tab class="custom-tab text-body-2">{{ $t("tax_disc") }}</v-tab>
      <v-tab class="custom-tab text-body-2">{{ $t("print_salary_slip") }}</v-tab>
      <v-tab class="custom-tab text-body-2">{{ $t("print_payroll_list") }}</v-tab>
      <v-tab class="custom-tab text-body-2">{{ $t("print_list_summary") }}</v-tab>
      <v-tab class="custom-tab text-body-2">{{ $t("print_insurance_list") }}</v-tab>
      <!-- <v-tab class="custom-tab text-body-2">{{ $t("bank_disc") }}</v-tab> -->
      <v-tab class="custom-tab text-body-2">{{ $t("attachments") }}</v-tab>
    </v-tabs>

    <!--content tabs menu setting -->
    <v-tabs-items v-model="tab" class="documents-tab-items-fill">
      <v-tab-item>
        <v-container class="pa-0 ma-0 d-flex flex-column">
          <!-- InsuranceDisc -->
          <v-container class="pa-0 ma-0 d-flex align-end">
            <InsuranceDisc :workshop="workshopData" :employee="employeeData" />
          </v-container>
          <div class="page-root_card pa-3 ma-0 d-flex flex-column">
            <TableInfoMonthly
              @workshop-items="handlerWorshop"
              @employee-items="handlerEmployee"
            />
          </div>
        </v-container>
      </v-tab-item>

      <v-tab-item>
        <v-container class="pa-4 pt-6 ma-0 d-flex flex-column gap-3">
          <!-- tax Disc -->
          <v-container class="pa-0 ma-0 d-flex align-end">
            <TaxDisc
              :employee="employeeData"
              :call="callFunction"
              @stop-loading="handleStoploading"
            />
          </v-container>
          <v-container class="pa-0 ma-0 d-flex right">
            <v-btn
              :loading="loading"
              @click="submitTaxDisc()"
              class="ma-0 pa-0"
              color="primary"
              height="32"
            >
              {{ $t("get-info") }}
            </v-btn>
          </v-container>
        </v-container>
      </v-tab-item>

      <v-tab-item>
        <v-container class="pa-3 ma-0 d-flex flex-column">
          <!-- print salary payslip -->
          <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
            <v-card-text class="pa-0 ma-0 pb-1 text-body-1"
              >{{ $t("print_salary_slip") }}:</v-card-text
            >
          </v-container>
          <div class="page-root_Print pa-0 ma-0 d-flex flex-column">
            <TablePrintPaysli @print-data="handlePrintData" />
          </div>
        </v-container>
      </v-tab-item>

      <v-tab-item>
        <v-container class="pa-4 ma-0 d-flex flex-column gap-4">
          <!-- print -->
          <v-container class="pa-0 ma-0 d-flex justify-space-between">
            <v-card-text class="pa-0 ma-0 mt-2 text-body-1"
              >{{ $t("print_payroll_list") }}:</v-card-text
            >
            <v-btn
              :loading="loading"
              @click="PrintSalary()"
              class="ma-0 pa-0"
              color="grey darken-2"
              height="28"
              outlined
            >
              <p class="font-weight-thin mb-0 me-2">
                {{ $t("print") }}
              </p>
              <v-icon> mdi-printer-outline </v-icon>
            </v-btn>
          </v-container>
          <div class="pa-0 ma-0 d-flex flex-column">
            <PrintSalaryList @salaryListObject="handleSalaryListData" />
          </div>
        </v-container>
      </v-tab-item>

      <v-tab-item>
        <div class="documents-tab-summary-scroll">
          <v-container class="pa-4 ma-0 d-flex flex-column gap-6">
            <v-container class="pa-0 ma-0 d-flex justify-space-between">
              <v-card-text class="pa-0 ma-0 mt-2 text-body-1"></v-card-text>
              <v-btn
                :loading="loading"
                @click="print_S()"
                class="ma-0 pa-0"
                color="grey darken-2"
                height="28"
                outlined
              >
                <p class="font-weight-thin mb-0 me-2">
                  {{ $t("print") }}
                </p>
                <v-icon> mdi-printer-outline </v-icon>
              </v-btn>
            </v-container>
            <!-- print -->
            <PrintSummeryList @summeryListObject="handleSummeryListData" />
            <v-dialog
              v-if="PrintSummery_"
              v-model="PrintSummery_"
              :fullscreen="isMobile"
              :hide-overlay="isMobile"
              width="90%"
            >
              <v-card>
                <v-col class="d-flex pb-0">
                  <v-btn icon color="grey darken-2" @click="PrintSummery_ = false">
                    <v-icon class="close-hover" large> mdi-close </v-icon>
                  </v-btn>
                  <p class="mx-auto font-weight-medium mt-2">
                    {{ $t("print") }}
                  </p>
                </v-col>
                <v-row class="ma-0">
                  <PrintSummery
                    ref="printRef"
                    :header-prop="printHeaderSummery"
                    :items-prop="items"
                    :dialog="printDialog"
                    :multiLineCells="true"
                    :title="$t($route.name)"
                  />
                </v-row>
                <v-card-actions />
              </v-card>
            </v-dialog>
          </v-container>
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="documents-tab-insurance-scroll">
          <v-container class="pa-5 pt-3 ma-0 d-flex flex-column gap-3">
            <v-container class="pa-0 ma-0 d-flex justify-space-between">
              <v-card-text class="pa-0 ma-0 mt-2 text-body-1"></v-card-text>
              <v-btn
                :loading="loading"
                @click="print_insurancelist()"
                class="ma-0 pa-0"
                color="grey darken-2"
                height="28"
                outlined
              >
                <p class="font-weight-thin mb-0 me-2">
                  {{ $t("print") }}
                </p>
                <v-icon> mdi-printer-outline </v-icon>
              </v-btn>
            </v-container>
            <!-- print -->
            <InsuranceList ref="insuranceListRef" />
          </v-container>
        </div>
      </v-tab-item>

      <!-- <v-tab-item>
        <v-container class="pa-4 ma-0 d-flex flex-column gap-1">
          <v-container class="pa-0 ma-0 d-flex right">
            <v-btn
              :loading="loading"
              @click="submitTaxDisc()"
              class="ma-0 pa-0"
              color="primary"
              height="32"
            >
              {{ $t("getGroupPeymentFile") }}
            </v-btn>
          </v-container>
          <div class="page-root-attachment pa-0 ma-0 d-flex flex-column">
            <TableBank @print-data="handlePrintData" />
          </div>

        </v-container>
      </v-tab-item> -->

      <!--attachment -->
      <v-tab-item class="documents-tab-attachment-fill">
        <v-container
          class="pa-4 ma-0 d-flex flex-column documents-tab-attachment-container"
        >
          <div class="page-root-attachment pa-0 ma-0 d-flex flex-column fill-height">
            <TableAttachment attachment-type="salary" @snackbar="showSnackbar" />
          </div>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    <!--  snackbar --->
    <v-snackbar
      v-if="snakbar"
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="loading"
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>
<script>
import InsuranceDisc from "@/views/dashboard/pages/payroll/saleryOperations/partial/details/InsuranceDisc.vue";
import TableInfoMonthly from "@/views/dashboard/pages/payroll/saleryOperations/partial/details/TableInfoMonthly.vue";
import TaxDisc from "@/views/dashboard/pages/payroll/saleryOperations/partial/details/TaxDisc.vue";
import TablePrintPaysli from "@/views/dashboard/pages/payroll/saleryOperations/partial/details/TablePrintPaysli.vue";
import PrintSalaryList from "@/views/dashboard/pages/payroll/saleryOperations/partial/details/PrintSalaryList.vue";
import PrintSummeryList from "@/views/dashboard/pages/payroll/saleryOperations/partial/details/PrintSummeryList.vue";
import InsuranceList from "@/views/dashboard/pages/payroll/saleryOperations/partial/details/InsuranceList.vue";
import TableAttachment from "@/views/dashboard/pages/payroll/saleryOperations/partial/details/TableAttachment.vue";
import TableBank from "@/views/dashboard/pages/payroll/saleryOperations/partial/details/TableBank.vue";
import PrintPayslip from "@/views/dashboard/pages/payroll/saleryOperations/partial/details/PrintPayslip.vue";
import PrintSummery from "@/views/dashboard/pages/payroll/saleryOperations/partial/details/PrintSummery.vue";

export default {
  components: {
    InsuranceDisc,
    TableInfoMonthly,
    TaxDisc,
    TablePrintPaysli,
    PrintSalaryList,
    PrintSummeryList,
    InsuranceList,
    TableAttachment,
    TableBank,
    PrintPayslip,
    PrintSummery,
  },
  data() {
    return {
      tab: 0,
      employeeData: [],
      workshopData: [],
      currencyId: null,
      name: null,
      salaryList: null,
      summeryList: null,
      saleryFactorsTemplate: null,
      PrintSummery_: false,
      // PrintSalaryList_: false,
      loading: false,
      callFunction: false,
      snakbar: false,
      snakbarText: null,
      snakbarColor: null,
      printHeaders: "",
      printHeaderSummery: "",
      paySlipContractLogo: "",
    };
  },
  watch: {
    "$route.query.tab"() {
      this.setTabFromRoute();
    },
    salaryFactorItems: {
      deep: true,
      handler(val) {
        if (val) {
          let obj = JSON.parse(JSON.stringify(val));
          const data = (obj.items.data || []).map((item) => ({
            ...item,
            workshop_name: item.workshop?.name || "",
          }));
          this.items = data || [];
        }
      },
    },
  },
  beforeMount() {
    this.printHeaders = [
      { text: this.$t("name"), value: "name" },
      { text: this.$t("baseInfo"), value: "performance_" },
      { text: this.$t("performance_"), value: "performanceAmount" },
      { text: this.$t("benefits&salary"), value: "benefitsSalary" },
      { text: this.$t("amount"), value: "benefitAmount", sum: "benefitAmountSum" },
      { text: this.$t("deductions"), value: "deductions" },
      { text: this.$t("amount"), value: "deductionAmount", sum: "deductionAmountSum" },
    ];
    this.printHeaderSummery = [
      { text: this.$t("whole"), value: "whole" },
      { text: this.$t("amount"), value: "amount" },
    ];
  },
  mounted() {
    this.setTabFromRoute();
    this.loadPaySlipContractLogo();
  },
  methods: {
    loadPaySlipContractLogo() {
      try {
        const token = JSON.parse(localStorage.getItem("token") || "{}");
        const link = token?.init?.logo?.link;
        if (!link) return;
        this.$axios
          .get(this.$endpoint + "getdetail?select=urlToBase64&url=" + link)
          .then((res) => {
            const raw = res?.data;
            if (raw == null || raw === "") return;
            this.paySlipContractLogo = String(raw).startsWith("data:")
              ? String(raw)
              : `data:image/png;base64,${raw}`;
          })
          .catch(() => {});
      } catch (e) {}
    },
    handleSalaryListData(data) {
      this.salaryList = data;
    },
    handleSummeryListData(data) {
      this.summeryList = data;
    },
    print_insurancelist() {
      const comp = this.$refs.insuranceListRef;
      if (!comp || typeof comp.printReport !== "function") return;
      comp.printReport();
    },
    print_S() {
      this.$router.push({
        name: "reportViewer",
        params: {
          dataProp: this.summeryList,
          reportProp: "NewSummeryList",
        },
      });
    },
    PrintSalary() {
      this.$router.push({
        name: "reportViewer",
        params: {
          dataProp: this.salaryList,
          reportProp: "salaryList",
        },
      });
    },
    handlerWorshop(val) {
      this.workshopData = val;
    },
    handlerEmployee(val) {
      this.employeeData = val;
    },
    handlePrintData(rows) {
      if (!Array.isArray(rows)) {
        rows = [rows];
      }
      rows = rows.filter((r) => !r?.isSummary);
      this.items = rows.map((row) => {
        const benefits =
          row?.salaries?.filter((item) => item?.salary?.level === "benefit") || [];
        const deductions =
          row?.salaries?.filter((item) => item?.salary?.level === "deductions") || [];
        const configs = Array.isArray(row?.configs)
          ? row.configs
          : Object.values(row?.configs || {});
        const performances = configs.filter(
          (item) => item?.factor?.level === "performance"
        );
        const benefitSum = benefits.reduce((s, b) => s + Number(b?.value || 0), 0);
        // const deductionSum = deductions.reduce((s, d) => s + Number(d?.value || 0), 0);
        const deductionSum =
          deductions.reduce((s, d) => s + Number(d?.value || 0), 0) +
          Number(row.tax || 0) +
          Number(row.employee_insurance || 0);
        const performanceAmountSum = performances.reduce((sum, p) => {
          if (p?.day) return sum + Number(p.day);
          if (p?.hour) return sum + Number(p.hour);
          if (p?.min) return sum + Number(p.min);
          return sum;
        }, 0);
        return {
          ...row,

          // contract_logo: this.paySlipContractLogo || null,
          contract_logo: row?.contract_logo,
          id: row?.id || "",
          name: row?.employee?.user?.name || "",
          nationalCode:
            this.toPersianDigits(row?.employee?.user?.national_code ?? "") || "",
          personnelCode: this.toPersianDigits(row?.employee?.personnely ?? "") || "",
          month: this.toPersianDigits(row?.month ?? "") || "",
          year: this.toPersianDigits(row?.year ?? "") || "",
          performance_: performances
            .map((p) => this.toPersianDigits(p?.factor?.name || ""))
            .join("\n"),
          performanceAmount: this.toPersianDigits(
            performances
              .map((p) => {
                const parts = [];

                if (p?.day != null) parts.push(`${p.day} روز`);
                if (p?.hour != null) parts.push(`${p.hour} ساعت`);
                if (p?.min != null) parts.push(`${p.min} دقیقه`);
                if (p?.dayHourMin != null) parts.push(`${p.dayHourMin} (دقیقه/روز/ساعت)`);
                return parts.length ? parts.join(" ") : "0";
              })
              .join("\n")
          ),

          performanceAmountSum: this.toPersianDigits(performanceAmountSum),
          // benefits
          benefitsSalary: benefits.map((b) => b?.salary?.name || "").join("\n"),
          benefitAmount: benefits
            .map((b) => this.toPersianDigits(this.$numberFormat(b?.value || 0)))
            .join("\n"),
          benefitAmountSum: this.toPersianDigits(this.$numberFormat(benefitSum)),
          // deductions
          // deductions: deductions.map((d) => d?.salary?.name || "").join("\n"),
          deductions: [
            ...deductions.map((d) => d?.salary?.name || ""),
            "مالیات",
            "حق بیمه سهم بیمه شده",
          ].join("\n"),
          // deductionAmount: deductions
          //   .map((d) => this.toPersianDigits(this.$numberFormat(d?.value || 0)))
          //   .join("\n"),
          deductionAmount: [
            ...deductions.map((d) =>
              this.toPersianDigits(this.$numberFormat(d?.value || 0))
            ),
            this.toPersianDigits(this.$numberFormat(row.tax || 0)),
            this.toPersianDigits(this.$numberFormat(row.employee_insurance || 0)),
          ].join("\n"),
          deductionAmountSum: this.toPersianDigits(this.$numberFormat(deductionSum)),
          // net payable
          totalPayable: this.toPersianDigits(
            this.$numberFormat(benefitSum - deductionSum)
          ),
        };
      });
      this.$router.push({
        name: "reportViewer",
        params: {
          dataProp: this.items,
          reportProp: "Payroll_pay_slip",
        },
      });
    },
    toPersianDigits(value) {
      if (value == null || value === "") return value;
      const map = "۰۱۲۳۴۵۶۷۸۹";
      return String(value).replace(/\d/g, (d) => map[Number(d)]);
    },
    setTabFromRoute() {
      if (this.$route.query.tab !== undefined) {
        this.tab = Number(this.$route.query.tab);
      }
    },
    submitTaxDisc() {
      this.callFunction = true;
      this.loading = true;
    },
    handleStoploading() {
      this.callFunction = false;
      this.loading = false;
    },
    showSnackbar(payload) {
      this.snakbarText = payload?.text || this.$t("alert-register-success");
      this.snakbarColor = payload?.color || "success";
      this.snakbar = true;
    },
    fetchApi() {
      console.log("submit");
    },
  },
};
</script>

<style scoped>
.page-root {
  height: calc(100vh - 100px);
}
.page-root_card {
  height: calc(100vh - 398px);
}
.page-root_Print {
  height: calc(100vh - 188px);
}
.page-root-attachment {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}

.documents-tab-attachment-container {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}

.documents-tab-attachment-fill {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.documents-tab-item-fill {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.documents-tab-body-fill {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}
::v-deep .v-label {
  top: 10px !important;
}
::v-deep .v-label.v-label--active {
  top: 18px !important;
}
::v-deep.v-btn--icon.v-size--default {
  width: 20px;
  height: 20px;
}
::v-deep .v-slide-group__content {
  background-color: #f3f3f3 !important;
}
::v-deep
  .v-input--selection-controls__input:hover
  .v-input--selection-controls__ripple:before {
  background: #fff;
}
.theme--light.v-tabs > .v-tabs-bar {
  background-color: #eb4e4e;
}
.nav {
  background-color: #ffff;
}
.wrapper {
  border: 1px solid silver;
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: 100%;
}
.wrapper > div {
  border-left: 1px solid silver;
  cursor: pointer;
  width: 80px;
}
.wrapper > div:last-child {
  border-left: 0 !important;
}
.rtl {
  direction: rtl;
  text-align: right;
}
::v-deep .v-tabs-bar {
  border-radius: inherit;
  height: 42px;
}
::v-deep .v-tabs {
  flex: none;
}
.custom-tabs :deep(.v-tab:last-child) {
  border-radius: 8px 0px 0px 0px;
}
.custom-tab {
  min-width: 120px;
  padding: 12px 20px;
  border: 1px solid #e0e0e0 !important;
  background-color: #fff !important;
  font-weight: 500;
  color: #333 !important;
}
.custom-tab.v-tab--active {
  background-color: #1976d2 !important;
  color: white !important;
}
.active-btn {
  background-color: #d8f5df !important;
  border-color: #bdeec7 !important;
  color: #2d8a3d !important;
}
.copy-btn {
  background: #f2f9ff !important;
  border: 1px solid #d0e7ff !important;
  border-radius: 6px !important;
}
.v-card__text {
  width: auto;
}
.container {
  width: auto;
}
.hidden-input {
  display: none;
}
.wrapper-content {
  position: relative;
  min-height: 300px;
}
.fix-checkbox-label ::v-deep .v-label {
  top: 0 !important;
}

.documents-tab-items-fill {
  flex: 1 1 auto;
  min-height: 0;
}
.documents-tab-items-fill ::v-deep .v-window__container {
  height: 100%;
}
.documents-tab-items-fill ::v-deep .v-window-item {
  height: 100%;
}
.documents-tab-items-fill ::v-deep .v-window-item > .v-container {
  height: 100%;
}

.documents-tab-insurance-scroll {
  max-height: calc(100vh - 142px);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #b7c1d1 transparent;
}

.documents-tab-summary-scroll {
  max-height: calc(100vh - 142px);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #b7c1d1 transparent;
}

.documents-tab-insurance-scroll::-webkit-scrollbar,
.documents-tab-summary-scroll::-webkit-scrollbar {
  width: 6px;
}

.documents-tab-insurance-scroll::-webkit-scrollbar-track,
.documents-tab-summary-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.documents-tab-insurance-scroll::-webkit-scrollbar-thumb,
.documents-tab-summary-scroll::-webkit-scrollbar-thumb {
  background-color: #b7c1d1;
  border-radius: 999px;
  border: 1px solid transparent;
  background-clip: content-box;
}

.documents-tab-insurance-scroll::-webkit-scrollbar-thumb:hover,
.documents-tab-summary-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #8fa0ba;
}

.documents-tab-insurance-scroll
  ::v-deep
  .insurance-list-print
  .insurance-list-print__data-scroll
  table.insurance-list-print__data-table
  tbody
  td {
  font-size: 11px !important;
}
.documents-tab-insurance-scroll
  ::v-deep
  .insurance-list-print
  table.insurance-list-print__footer-table
  tfoot
  td {
  font-size: 11px !important;
}
.documents-tab-insurance-scroll
  ::v-deep
  .insurance-list-print
  table.insurance-list-print__footer-table
  tfoot
  td.sum-title {
  font-size: 11px !important;
}
</style>

<style>
@media print {
  body.documents-print-insurance-only .documents-tab-insurance-scroll {
    max-height: none !important;
    overflow: visible !important;
    height: auto !important;
  }
  body.documents-print-insurance-only .documents-tab-items-fill {
    overflow: visible !important;
    max-height: none !important;
    min-height: 0 !important;
  }
  body.documents-print-insurance-only .v-tabs-items {
    overflow: visible !important;
    height: auto !important;
  }
}
</style>
